import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT, STATIC_ROOT } from '../../../../constants';
import { VALIDATED } from '../../../../services/checkout/constants';
import { ENTERPRISE_CARD_NAME, ENTERPRISE_CARD_PARTNER_EBC_ID } from '../../../../constants/ebon';

import { getPartner } from '../../../../services/partner/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Stepper from '../Stepper';
import { HeadComponent } from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import ConfirmationEbonPageKycBloc from './kyc/ConfirmationEbonPageKycBloc';
import ConfirmationEbonPageMessageBloc from './message/ConfirmationEbonPageMessageBloc';
import ConfirmationEbonPageStateController from './ConfirmationEbonPageStateController';

import './ConfirmationEbonPage.scss';

const ConfirmationEbonPage = ({
    i18n,
    BRAND_NAME,
    user,
    orderId,
    partner,
    paypalCost,
    paymentRef,
    checkoutSessionId,
    checkoutPaymentId,
    fetchingOrder,
    confirmedOrder
}) => {
    const [loading, setLoading] = useState(false);
    const [kyc, setKyc] = useState(false);
    const [kycValidated, setKycValidated] = useState(false);
    const [ebonOrderState, setEbonOrderState] = useState(null);
    const [detailsInterval, setDetailsInterval] = useState(null);

    const isEnterpriseCard = partner && partner.ebcId === ENTERPRISE_CARD_PARTNER_EBC_ID;
    const partnerId = partner ? partner.id : null;
    const partnerName = isEnterpriseCard ? ENTERPRISE_CARD_NAME : partner ? partner.name : '';
    const userEmail = user ? user.email : null;

    // retour sans cko-* possible : état de la commande accepté
    const isOrderValidated = () =>
        ebonOrderState === VALIDATED || (!!confirmedOrder && confirmedOrder.state === VALIDATED);

    return (
        <div className="template template-primary flex-container-v">
            <ConfirmationEbonPageStateController
                orderId={orderId}
                partnerId={partnerId}
                partnerName={partnerName}
                checkoutSessionId={checkoutSessionId}
                checkoutPaymentId={checkoutPaymentId}
                paypalCost={paypalCost}
                paymentRef={paymentRef}
                setLoading={setLoading}
                setKyc={setKyc}
                kycValidated={kycValidated}
                ebonOrderState={ebonOrderState}
                setEbonOrderState={setEbonOrderState}
                detailsInterval={detailsInterval}
                sessionEmail={userEmail}
            />

            <div className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                            <img
                                src={`${STATIC_ROOT}/logo.png`}
                                alt={BRAND_NAME}
                                width="130"
                                height="53"
                            />
                        </LocalizedNavLink>
                        <Stepper steps={i18n.STEPS} current={4} />
                    </header>
                </div>
            </div>
            <main id="p-ebon-confirmation" className="conteneur conteneur-mobile">
                <HeadComponent
                    title={i18n.CONFIRMATION.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.EBON_CONFIRMATION_PATH}`}
                />
                <Stepper steps={i18n.STEPS} current={4} cssClass="mobileDisplay" />

                <div className="congratulation-container">
                    {loading && !kycValidated && (
                        <React.Fragment>
                            <LoadingComponent />
                            <p className="pending-message">
                                {convertHtmlToReactDomWithParams(i18n.CONFIRMATION.PENDING_MESSAGE)}
                            </p>
                        </React.Fragment>
                    )}

                    <ConfirmationEbonPageKycBloc
                        orderId={orderId}
                        checkoutSessionId={checkoutSessionId}
                        checkoutPaymentId={checkoutPaymentId}
                        paypalCost={paypalCost}
                        paymentRef={paymentRef}
                        fetchingOrder={fetchingOrder}
                        ebonOrderState={ebonOrderState}
                        kyc={kyc}
                        setKyc={setKyc}
                        kycValidated={kycValidated}
                        setKycValidated={setKycValidated}
                        detailsInterval={detailsInterval}
                        setDetailsInterval={setDetailsInterval}
                    />

                    {!kyc && !loading && isOrderValidated() && (
                        <ConfirmationEbonPageMessageBloc
                            partner={partner}
                            isEnterpriseCard={isEnterpriseCard}
                            sessionEmail={userEmail}
                            confirmedOrder={confirmedOrder}
                        />
                    )}
                </div>
            </main>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paypalCost = params.paypal;
    const paymentRef = params.ref;

    const confirmedOrder = state.ebon.confirmedOrder;
    const partner = getPartner(state, confirmedOrder.partnerId);

    return {
        i18n: state.i18n.page.EBON,
        BRAND_NAME: state.i18n.common.BRAND_NAME,
        user: state.account.user,
        orderId,
        partner,
        paypalCost,
        paymentRef,
        checkoutSessionId: params['cko-session-id'],
        checkoutPaymentId: params['cko-payment-id'],
        fetchingOrder: state.ebon.fetchOrder,
        confirmedOrder: confirmedOrder
    };
};

export default withRouter(connect(mapStateToProps)(ConfirmationEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPage.js